// A cash balance's value on a given day, with interest compounded from its "as of" date (whole days,
// as the app counts them). Shared by cashCalc() and the period changes.
/* eslint-disable @typescript-eslint/no-explicit-any */
import { days } from './clock';
import { N } from './state';

export const COMP: Record<string, [number, string]> = { daily: [365, 'Daily'], monthly: [12, 'Monthly'], quarterly: [4, 'Quarterly'], yearly: [1, 'Yearly'] };
export function cashValueOn(c: any, d: string): number {
  const amt = N(c.amount), apr = N(c.apr) / 100, n = (COMP[c.comp] || COMP.monthly)[0];
  const t = c.asOf ? Math.max(0, days(c.asOf, d)) / 365 : 0;
  return apr > 0 ? amt * Math.pow(1 + apr / n, n * t) : amt;
}
